module.exports = __webpack_public_path__ + "static/img/popular-02.574ee4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/popular-02.jpg
// module id = t0dv
// module chunks = 1